<template>
  <card>
    <list
      v-if="$store.state.user.sections['infos']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "info_project",
          labelKey: "project",
          label: "Выберите проект",
          type: "select",
          modal: "info_project",
          selectKey: "title",
        },

        {
          col: " col-12 col-md-12",
          key: "type",
          labelKey: "type",
          label: "Тип",
          type: "static_radio",
          items: [
            { id: "error", title: "Ошибка" },
            { id: "info", title: "Инфо" },
          ],
        },
        {
          key: "name",
          col: "col-12",
          label: "Название",
          labelKey: "name",
          isMultiLang: true,
          type: "field",
        },
        {
          key: "description",
          label: "Описание",
          labelKey: "description",
          type: "html",
          textType: "text",
          isMultiLang: true,
        },
        {
          key: "position",
          label: "Позиция (чем больше, тем выше)",
          labelKey: "position",
          type: "field",
          textType: "number",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_info",
      itemLink: "infos",
      setLink: "infos",
      columns: [
        {
          key: "id",
          title: "ID",
        },
        {
          key: "name",
          title: "Название",
        },
        {
          key: "type",
          title: "Тип",
        },
        {
          key: "info_project",
          title: "Проект",
          object: "title",
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
